import { useSelector } from 'react-redux';
import StateInterface from '../redux/types';

export const useIsLoggedIn = () => useSelector<StateInterface, boolean>(state => state.login.isLoggedIn);

export default {
    useIsLoggedIn,
};
